<div style="height: 100%;">
  <button class="search-button" mat-button (click)="open()">
    <mat-icon>search</mat-icon>
  </button>
  <mat-form-field class="search" [class.search-open]="isOpen">
    <input #input (blur)="close()" matInput placeholder="Search...">
  </mat-form-field>
</div>


<!--<div>
  <div class="search-wrapper" [class.focus]="isFocused()" fxShow="false" fxShow.gt-mat="true">
    <mat-icon class="search-icon">search</mat-icon>
    <input type="search"
           autocomplete="off"
           spellcheck="off"
           class="search-input"
           [(ngModel)]="search"
           (focus)="focus()"
           (blur)="blur()"
           placeholder="Search">
  </div>
</div>
-->
